export const setPageTitle = (pageTitle, appName = "Pharmacy wiki") => {
  document.title = pageTitle ? `${pageTitle} | ${appName}` : appName;
}; 